const MAX_SIZE_ALLOWED = 3;

export function canMoreBanksBeAdded(arrayToCheckSize: number[]): boolean {
  return arrayToCheckSize.length < MAX_SIZE_ALLOWED;
}
